import '../../../../App.css'
import { FaPlay, FaPause, FaVolumeMute, FaStepBackward, FaStepForward, FaVolumeUp } from 'react-icons/fa';

const MusicPlayer = ({ toggle, isPlaying, currSong, toggleMute, isMuted, playNext, playPrevious, handleSeek, currentTime, duration, formatTime }) => {
  console.log(currSong, isPlaying)
  return (
    <section className='flex justify-center'>
      <div className='w-72 h-96 rounded-2xl py-4 bg-custom-gradient-1 dark:bg-custom-gradient-2 shadow-slate-600 dark:shadow-slate-800 shadow-md'>
        <div className='m-auto shadow-md w-[270px] h-[250px] bg-[#caf0f8] dark:bg-purple-500 rounded-xl py-2 '>
          <div className='m-auto font-[blanka] text-white  w-64 h-[90px] bg-slate-800 dark:bg-purple-950 rounded-xl p-4 shadow-slate-500 shadow-md'>
            <h1>Now Playing</h1>
            <p>{currSong}</p>
          </div>
          <div className='my-2'>
            <div className=' flex justify-center items-center gap-2 px-2'>
              <div className='w-full rounded-lg '>
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={(currentTime / duration) * 100 || 0}
                  onChange={handleSeek}
                  className='w-full'
                />
              </div>

              <div onClick={toggleMute} className='text-slate-600 dark:text-white cursor-pointer '>
                {isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
              </div>
            </div>
            <div className="flex justify-between text-xs px-2">
              <span>{formatTime(currentTime)}</span>
              <span className='pr-5'>{formatTime(duration)}</span>
            </div>

          </div>
          <div className='text-black flex gap-2 my-5 justify-center items-center'>
            <div onClick={playPrevious} className='cursor-pointer border-2 bg-slate-500 shadow-slate-900 shadow-md hover:shadow-slate-600 rounded-full w-10 h-10 flex justify-center items-center'>
              <FaStepBackward className='bg-slate-200 p-1 text-xl rounded-full' />
            </div>
            <div onClick={toggle} className='cursor-pointer border-2 bg-slate-500 shadow-slate-900 shadow-md hover:shadow-slate-600  rounded-full w-16 h-16 flex justify-center items-center'>
              {isPlaying ? <FaPause className='bg-slate-200 p-1 text-2xl rounded-full' /> : <FaPlay className='bg-slate-200 p-1 text-2xl rounded-full' />}
            </div>
            <div onClick={playNext} className='cursor-pointer border-2 bg-slate-500 shadow-slate-900 shadow-md hover:shadow-slate-600 rounded-full w-10 h-10 flex justify-center items-center'>
              <FaStepForward className='bg-slate-200 p-1 text-xl rounded-full' />
            </div>
          </div>
          <div className='font-[blanka] gap-2 flex justify-center items-center mt-10'>
            <img className='w-20 logo-rotate' src="./favicon2.png" alt="" />
            <h1>MP3 by Studio Mercy!</h1>
          </div>
        </div>

      </div>
    </section>
  )
}

export default MusicPlayer